exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".create-alert-modal .form-text{height:30px;padding:0 4px}.create-alert-modal .form-text,.create-alert-modal .form-textarea{border-radius:4px;border:1px solid #ccc;color:#333;width:100%;box-sizing:border-box}.create-alert-modal .form-textarea{padding:4px}.create-alert-modal .form-submit{margin-right:12px}.create-alert-modal .save-as-new{display:flex}.create-alert-modal .save-as-new label{margin-left:2px;margin-right:5px}.create-alert-modal .save-as-new input{margin-top:3px}.create-alert-modal .modal-footer{display:flex;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/pages/advancedSearch/Alerts/CreateAlertModal.less
// module id = 1646
// module chunks = 0